import { useMemo, useRef } from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

import { hashToBgColor, pluralize } from '../../utils/helper';

const ProjectItem = ({ eventInfo, onViewDetail }) => {
  const {
    extendedProps: { project, members, totalTimeLogged } = {},

    title,
  } = eventInfo.event || {};
  const positionRef = useRef({ x: 0, y: 0 });
  const popperRef = useRef(null);
  const areaRef = useRef(null);

  const eventBgColor = useMemo(
    () => project?.color || hashToBgColor(project?._id) || '#3498DB',
    [project]
  );

  const tooltipContent = useMemo(() => {
    return (
      <Box>
        <Typography>
          <b>{title}</b>
        </Typography>
        <Typography>
          <b>PL:</b> {project.project_lead?.full_name || '-'}
        </Typography>
        <Box>
          <Typography fontWeight="bold">Members:</Typography>
          <div sx={{ m: 0, p: 0 }}>
            {(members || []).map((item) => (
              <Typography
                key={item.full_name}
                sx={{
                  padding: 0,
                  minWidth: '100px',
                  textTransform: 'capitalize',
                }}>
                <b>{'- ' + item.full_name}</b>:{' '}
                {pluralize('hr', item.work_time_per_day || 0, true)}
              </Typography>
            ))}
          </div>
        </Box>
      </Box>
    );
  }, [project, members, title]);

  const handleMouseMove = (event) => {
    positionRef.current = { x: event.clientX, y: event.clientY };

    if (popperRef.current != null) {
      popperRef.current.update();
    }
  };

  return (
    <Tooltip
      title={tooltipContent}
      placement="bottom"
      arrow
      PopperProps={{
        popperRef,
        anchorEl: {
          getBoundingClientRect: () => {
            const { y, height } = areaRef.current.getBoundingClientRect();
            return new DOMRect(positionRef.current.x, y + height, 0, 0);
          },
        },
      }}>
      <Box
        sx={{
          padding: '4px',
          cursor: 'pointer',
          backgroundColor: eventBgColor,
        }}
        ref={areaRef}
        onMouseMove={handleMouseMove}
        onClick={onViewDetail}>
        <Typography
          variant="subtitle1"
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            fontWeight: 600,
          }}>
          {title}
        </Typography>
        <Typography>- Members: {members.length || <i>None</i>}</Typography>
        <Typography>
          - Total: {pluralize('hr', totalTimeLogged, true)}
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default ProjectItem;
